const ACCESS_LINK_STORAGE_KEY = "vocabularium_access_link";

function readSearchParams(location) {
  const search = new URLSearchParams(location?.search || "");
  const hashRaw = String(location?.hash || "").replace(/^#/, "");
  const hashQuery = hashRaw.includes("?")
    ? hashRaw.slice(hashRaw.indexOf("?") + 1)
    : hashRaw.includes("=")
      ? hashRaw
      : "";
  return {
    search,
    hash: new URLSearchParams(hashQuery),
  };
}

function firstParam(search, hash, name) {
  return String(search.get(name) || hash.get(name) || "")
    .replace(/\s+/g, "")
    .trim();
}

function readAccessLinkFromLocation(location = window.location) {
  const { search, hash } = readSearchParams(location);
  const invite = firstParam(search, hash, "invite");
  if (invite) {
    return { kind: "invite", token: invite };
  }
  const access = firstParam(search, hash, "access").toLowerCase();
  const token = firstParam(search, hash, "token");
  if ((access === "approve" || access === "reject") && token) {
    return { kind: "decide", action: access, token };
  }
  return null;
}

function clearAccessLinkFromLocation(
  location = window.location,
  historyApi = window.history
) {
  const url = new URL(location.href);
  url.searchParams.delete("invite");
  url.searchParams.delete("access");
  url.searchParams.delete("token");
  if (url.hash && /invite=|access=|token=/.test(url.hash)) {
    url.hash = "";
  }
  const next = `${url.pathname}${url.search}${url.hash}`;
  historyApi.replaceState(null, "", next);
  return next;
}

function readStoredAccessLink(storage = window.sessionStorage) {
  try {
    const parsed = JSON.parse(storage.getItem(ACCESS_LINK_STORAGE_KEY) || "null");
    if (parsed?.kind === "invite" && parsed.token) return parsed;
    if (
      parsed?.kind === "decide" &&
      parsed.token &&
      (parsed.action === "approve" || parsed.action === "reject")
    ) {
      return parsed;
    }
  } catch {
    // ignore
  }
  return null;
}

function writeStoredAccessLink(link, storage = window.sessionStorage) {
  try {
    storage.setItem(ACCESS_LINK_STORAGE_KEY, JSON.stringify(link));
  } catch {
    // ignore
  }
}

function clearStoredAccessLink(storage = window.sessionStorage) {
  try {
    storage.removeItem(ACCESS_LINK_STORAGE_KEY);
  } catch {
    // ignore
  }
}

function consumeAccessLinkFromLocation(
  location = window.location,
  historyApi = window.history,
  storage = window.sessionStorage
) {
  const fromUrl = readAccessLinkFromLocation(location);
  if (fromUrl) {
    writeStoredAccessLink(fromUrl, storage);
    clearAccessLinkFromLocation(location, historyApi);
    return fromUrl;
  }
  return readStoredAccessLink(storage);
}

function hasAccessLinkPending(
  location = window.location,
  storage = window.sessionStorage
) {
  return Boolean(readAccessLinkFromLocation(location) || readStoredAccessLink(storage));
}

module.exports = {
  ACCESS_LINK_STORAGE_KEY,
  readAccessLinkFromLocation,
  clearAccessLinkFromLocation,
  readStoredAccessLink,
  writeStoredAccessLink,
  clearStoredAccessLink,
  consumeAccessLinkFromLocation,
  hasAccessLinkPending,
};
